export default {
  summary_one: '{{count}} article supprimé · non disponible pour votre heure de retrait',
  summary_other: '{{count}} articles supprimés · non disponibles pour votre heure de retrait',
  reason: 'Uniquement commandable {{schedule}} — votre retrait est à {{time}}.',
  change_pickup_time: "Modifier l'heure de retrait",
  dismiss: 'Ignorer',
};
